import React from 'react';
import './Common.css';

const Loading = ({ size = 'medium', text }) => {
  return (
    <div className="loading-container">
      <div className={`loading-spinner loading-spinner--${size}`}></div>
      {text && <p className="loading-text">{text}</p>}
    </div>
  );
};

export default Loading;
